import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

import { resolveImage } from "../../lib/media";
import Picture from "../Picture";

const Reviews = ({ reviews = [], isLoading = false }) => {
  if (!isLoading && (!reviews || reviews.length === 0)) return null;

  const renderSkeletons = Array(6)
    .fill(0)
    .map((_, i) => <ReviewSkeleton key={i} />);

  const renderReviews = (reviews || []).map((review) => {
    const photo = review.photo;
    const photoSrc = typeof photo === "string" ? photo : photo?.src;
    const photoV2 = typeof photo === "object" ? photo : null;
    const resolved = resolveImage(photoSrc, photoV2, "review");
    return (
      <div
        key={review.id}
        className="h-[342px] w-[256px] shrink-0 overflow-hidden rounded-lg border border-gray-200"
      >
        {resolved.isV2 ? (
          <Picture
            resolved={resolved}
            alt={review.title || "Review Image"}
            className="h-full w-full"
            imgClassName="h-full w-full object-cover"
          />
        ) : (
          <LazyLoadImage
            className="h-full w-full object-cover"
            height="100%"
            width="100%"
            src={resolved.src}
            alt={review.title || "Review Image"}
            effect="blur"
          />
        )}
      </div>
    );
  });

  return (
    <div className="mt-8 px-5">
      <h2 className="text-[20px] font-normal capitalize tracking-[0.5px] text-checkoutText">
        Customer Reviews
      </h2>

      <div className="hide-scrollbar mt-4 flex gap-x-4 overflow-x-auto">
        {isLoading ? renderSkeletons : renderReviews}
      </div>
    </div>
  );
};

const ReviewSkeleton = () => {
  return (
    <div className="h-[342px] w-[256px] shrink-0 animate-pulse overflow-hidden rounded-lg border border-gray-200 bg-gray-200" />
  );
};

export default Reviews;
